import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Toolbar from './components/Toolbar';
import Footer from './components/Footer';
import Welcome from './pages/Welcome';  // Import Welcome component
import './App.css';  // Your custom styles
import Inspire from './pages/Inspire';
import Impressum from './pages/Impressum';
import DataProtectionPage from './pages/DataProtectionPage';
import CookieConsentModal from './components/CookieConsentModal'; // Import the modal component
import ContactPage from './pages/ContactPage';
import LearnMore from './pages/LearnMore';
import ChatPage from './components/ChatPage';
//import ChatBox from './components/ChatBox';
import Chat from './pages/Chat';  // Import the Chat component
import axiosInstance from './axiosConfig';  // Import the Axios instance


const App = () => {

  const [showChat, setShowChat] = useState(false);

  const [messages, setMessages] = useState([]);
  // Function to handle the chat open/close
  const handleChatToggle = () => setShowChat(!showChat);


  const fetchMessages = async () => {
    try {
      const session_id = localStorage.getItem('session_id');
      if (session_id) {
      //const response = await axios.get(`http://localhost:8000/messages/${session_id}`);
      const response = await axiosInstance.get(`/messages/${session_id}`);  // Your endpoint here

      setMessages(response.data);  // Assuming the API returns the messages in the response data
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
      //setError('Failed to load messages');
      //setLoading(false);
    }
  };

  useEffect(() => {
  fetchMessages(); // Fetch messages when component mounts
  }, []);  // Only run once

  

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "rgba(255, 245, 230, 0.3)" }}>
        {/* Toolbar */}
        <Toolbar handleChatToggle={handleChatToggle} />
        <CookieConsentModal showChat={setShowChat}/> {/* Display the modal */}


        {/* Main content area */}
        <div className="flex-grow-1">
          <Routes>
            <Route path="/welcome" element={<Welcome 
              showChat={showChat}
              setShowChat={setShowChat}
              handleChatToggle={handleChatToggle}
              messages={messages}
              setMessages={setMessages}
              />} />  {/* Define route */}
            <Route path="/" element={<Welcome 
              showChat={showChat}
              setShowChat={setShowChat}
              handleChatToggle={handleChatToggle}
              messages={messages}
              setMessages={setMessages}
            />} />
            <Route path="/home" element={<Welcome 
              showChat={showChat}
              setShowChat={setShowChat}
              handleChatToggle={handleChatToggle}
              messages={messages}
              setMessages={setMessages}
            />} />
            <Route path="/about" element={<h2>Chatte mit dem Assistenten</h2>} />
            <Route path="/find-gift" element={<Inspire handleChatToogle={handleChatToggle} />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/learn-more" element={<LearnMore
              handleChatToggle={handleChatToggle}
            />} />
            <Route path="/data-protection" element={<DataProtectionPage />} />
            <Route path="/chat" element={<ChatPage />} />
          </Routes>
        </div>

      <Chat 
        showChat={showChat}
        setShowChat={setShowChat}
        handleChatToggle={handleChatToggle}
        messages={messages}
        setMessages={setMessages}
      />  {/* Use the Chat component */}



        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;